var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.66669C16.6604 3.67779 17.7402 3.7662 18.4445 4.47055C19.25 5.27601 19.25 6.57237 19.25 9.16509V14.6651C19.25 17.2578 19.25 18.5542 18.4445 19.3596C17.6391 20.1651 16.3427 20.1651 13.75 20.1651H8.25C5.65728 20.1651 4.36091 20.1651 3.55546 19.3596C2.75 18.5542 2.75 17.2578 2.75 14.6651V9.16509C2.75 6.57237 2.75 5.27601 3.55546 4.47055C4.25981 3.7662 5.33956 3.67779 7.33333 3.66669",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.2833L9.82143 13.75L13.75 10.0833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 3.20831C7.33325 2.44892 7.94886 1.83331 8.70825 1.83331H13.2916C14.051 1.83331 14.6666 2.44892 14.6666 3.20831V4.12498C14.6666 4.88437 14.051 5.49998 13.2916 5.49998H8.70825C7.94886 5.49998 7.33325 4.88437 7.33325 4.12498V3.20831Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistory);
export default __webpack_public_path__ + "static/media/OrderHistory.b4a11940a413e276411d1c21e06f7f41.svg";
export { ForwardRef as ReactComponent };